import { FormHelperText } from "@material-ui/core";
import React from "react";

const ImportError = ({ field, errors }) => {
	const fieldErrors = errors[field];

	return fieldErrors ? (
		<FormHelperText error>{fieldErrors.join(", ")}</FormHelperText>
	) : null;
};

export default ImportError;
